import { ReactNode, FC } from 'react';
import Breadcrumb from 'antd/es/breadcrumb';
import './style.scss';
import ArrowRight from '@/assets/svgFile/ArrowRight';

export type BreadcrumbOptionsItemType = {
    href?: () => void;
    label: string;
};
export type BreadcrumbOptionsProps = {
    options: BreadcrumbOptionsItemType[];
    separator?: ReactNode;
};
export type MergeBreadcrumbType = typeof Breadcrumb & {
    Options: FC<BreadcrumbOptionsProps>;
};

/**
 * @desc 封装 BreadcrumbOptions 组件，指定传入 options 生成
 */
const BreadcrumbOptions: FC<BreadcrumbOptionsProps> = (props) => {
    const items: any = props.options.map((item) => {
        return {
            title: item.label,
            onClick: item.href ? item.href : null,
        };
    });

    return <Breadcrumb separator={props.separator} items={items} />;
};
BreadcrumbOptions.defaultProps = {
    separator: <ArrowRight />,
};

(Breadcrumb as MergeBreadcrumbType).Options = BreadcrumbOptions;

export default Breadcrumb;
